var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.938 7.99999H21C21.5304 7.99999 22.0391 8.21071 22.4142 8.58578C22.7893 8.96085 23 9.46956 23 9.99999V14C23 14.5304 22.7893 15.0391 22.4142 15.4142C22.0391 15.7893 21.5304 16 21 16H19.938C19.6942 17.9333 18.7533 19.7112 17.2917 21C15.8302 22.2888 13.9486 23 12 23V21C13.5913 21 15.1174 20.3679 16.2426 19.2426C17.3679 18.1174 18 16.5913 18 15V8.99999C18 7.40869 17.3679 5.88257 16.2426 4.75735C15.1174 3.63213 13.5913 2.99999 12 2.99999C10.4087 2.99999 8.88258 3.63213 7.75736 4.75735C6.63214 5.88257 6 7.40869 6 8.99999V16H3C2.46957 16 1.96086 15.7893 1.58579 15.4142C1.21071 15.0391 1 14.5304 1 14V9.99999C1 9.46956 1.21071 8.96085 1.58579 8.58578C1.96086 8.21071 2.46957 7.99999 3 7.99999H4.062C4.30603 6.06689 5.24708 4.28926 6.70857 3.00067C8.17007 1.71207 10.0516 1.00107 12 1.00107C13.9484 1.00107 15.8299 1.71207 17.2914 3.00067C18.7529 4.28926 19.694 6.06689 19.938 7.99999ZM3 9.99999V14H4V9.99999H3ZM20 9.99999V14H21V9.99999H20ZM7.76 15.785L8.82 14.089C9.77308 14.686 10.8754 15.0018 12 15C13.1246 15.0018 14.2269 14.686 15.18 14.089L16.24 15.785C14.9693 16.5811 13.4995 17.0023 12 17C10.5005 17.0023 9.03074 16.5811 7.76 15.785Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/support-icon.9c13e36df7292e7061b98103d0e253f0.svg";
export { ForwardRef as ReactComponent };